import { Theme } from '@mui/material/styles/createTheme';
import { Client } from '@provision/entity-types';
import { portalPaths } from '@provision/portal-routes';
import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { ActivityRefChip } from 'src/components/ActivityList/activity-ref-chip';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export const buildClientToAddressMessage = (activity: ActivityFeed): ActivityMessage[] => {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';
  const client = Object.fromEntries(
    activity.changes
      .filter(({ name }) => name.startsWith('client.'))
      .map((value) => ({
        ...value,
        name: value.name.replace('client.', ''),
      }))
      .map(({ name, value }) => [name, value]),
  ) as Pick<Client, 'firstName' | 'lastName' | 'clientId'>;

  if (!client.firstName && !client.lastName) {
    return [];
  }

  switch (activity.activityType) {
    case 'createN2NRelationship': {
      return [
        {
          id: activity.id,
          icon: 'join_inner',
          color: (theme: Theme) => theme.palette.custom.OV.sys.primary,
          message: (
            <>
              {actorName} associated{' '}
              <ActivityRefChip
                label={`${client.firstName} ${client.lastName}`}
                icon={<DynamicIcon name="person" weight={400} />}
                iconColor={(theme) => theme.palette.custom.OV.sys.tertiary}
                clickable
                path={portalPaths.client.full(client.clientId)}
              />{' '}
              with the site
            </>
          ),
          timestamp: activity.timestamp,
        },
      ];
    }
    case 'deleteN2NRelationship': {
      return [
        {
          id: activity.id,
          icon: 'link_off',
          color: (theme: Theme) => theme.palette.custom.OV.sys.error,
          message: (
            <>
              {actorName} removed{' '}
              <ActivityRefChip
                label={`${client.firstName} ${client.lastName}`}
                icon={<DynamicIcon name="person" weight={400} />}
                iconColor={(theme) => theme.palette.custom.OV.sys.tertiary}
                clickable
                path={portalPaths.client.full(client.clientId)}
              />{' '}
              from the site
            </>
          ),
          timestamp: activity.timestamp,
        },
      ];
    }
    default:
      return [];
  }
};
